import { FormikProps } from "formik";

import Stack from "components/Stack";

import {
  TRANSACTION_LOAN_TYPE_OPTIONS,
  TRANSACTION_TERM_TYPE_OPTIONS,
} from "pages/Deal/FinancingEvents/constants";
import TransactionSelectField from "pages/Deal/FinancingEvents/TransactionFields/TransactionSelectField";
import TransactionTextField from "pages/Deal/FinancingEvents/TransactionFields/TransactionTextField";
import TransactionTypeSpecificHeader from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionTypeSpecificHeader";

import { ITransactionValuesForm } from "entities/Deal/sdk";

export interface ITransactionDebtModifyForm {
  formik: FormikProps<ITransactionValuesForm>;
  lastUpdatedInformation: string | null;
  transactionIdentifier?: string;
}

const TransactionDebtModifyForm = ({
  formik,
  transactionIdentifier,
  lastUpdatedInformation,
}: ITransactionDebtModifyForm) => (
  <>
    <TransactionTypeSpecificHeader
      transactionIdentifier={transactionIdentifier}
      transactionType={formik.values.transaction_type}
      lastUpdatedInformation={lastUpdatedInformation}
    />
    <Stack
      gap={1}
      rowGap={3}
      padding={2}
      marginTop={2}
      gridTemplateColumns="1fr 1fr"
      display="grid"
    >
      <TransactionSelectField
        formik={formik}
        options={TRANSACTION_TERM_TYPE_OPTIONS}
        inputLabel="Term type"
        fieldName="debt_transaction.term_type"
      />
      <TransactionTextField
        fieldName="debt_transaction.term"
        label="Term"
        isNumber
        formik={formik}
      />
      <TransactionTextField
        fieldName="debt_transaction.rate"
        label="Rate"
        isNumber
        formik={formik}
      />
      <TransactionSelectField
        formik={formik}
        options={TRANSACTION_LOAN_TYPE_OPTIONS}
        inputLabel="Loan type"
        fieldName="debt_transaction.loan_type"
      />
      <TransactionTextField
        fieldName="debt_transaction.other_sources"
        label="Other sources"
        formik={formik}
      />
      <TransactionTextField
        fieldName="debt_transaction.other_sources_amount"
        label="Other sources amount"
        isNumber
        formik={formik}
        showDollarSign
      />
      <TransactionTextField
        fieldName="debt_transaction.debt_service_coverage_ratio"
        label="Debt service covarege ratio"
        isNumber
        formik={formik}
      />
      <TransactionTextField
        fieldName="debt_transaction.number_of_years_extension"
        label="Number of years extension (if applicable)"
        isNumber
        formik={formik}
      />
    </Stack>
  </>
);

export default TransactionDebtModifyForm;
